import type { Dispatch, SetStateAction } from 'react'

export type LoadingProps = Record<string, never>

export interface LoadingContextProps {
  loading: boolean
  setLoading: Dispatch<SetStateAction<boolean>>
}

export const LoadingContextDefaultValues: LoadingContextProps = {
  loading: false,
  setLoading: () => {},
}
